import { BaseModel } from "sjs-base-model";

export default class GeneralProjectsModel extends BaseModel {
  public readonly project_count: number = 0;
  public readonly role_count: number = 0;
  public readonly invitation_count: number = 0;
  public readonly declined_invitation_count: number = 0;
  public readonly roleapplication_count: number = 0;

  constructor(data: Partial<GeneralProjectsModel>) {
    super();

    this.update(data);
  }
}
